// extracted by mini-css-extract-plugin
export default {"root":"SignUpComplitedForm_root__zrH-7","btn":"SignUpComplitedForm_btn__3Fb82"};